import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const CustomWidget = ({ title, children, style }) => {
  const { t } = useTranslation();
  return (
    <Box sx={{ minWidth: 415, minHeight: 180, ...style }}>
      {title ? (
        <div>
          <Typography
            sx={{ textAlign: "center", fontSize: 20, fontWeight: "bold" }}
          >
            {t(title)}
          </Typography>
        </div>
      ) : null}
      <div>
        <Box>{children}</Box>
      </div>
    </Box>
  );
};

export default CustomWidget;
